import { Breadcrumb } from "@volvo/vcdk-react/Breadcrumb"
import { Breadcrumbs } from "@volvo/vcdk-react/Breadcrumbs"
import {Divider} from "@volvo/vcdk-react/Divider";
const CustomBreadcrumb = (
    {crumbs}:{crumbs:string[]}
) => {
   
    return (
        <>
            <style>
                {`
                    vcdk-divider.crumbdivider::part(divider) {
                        margin-top: 0;
                        margin-bottom: 14px;
                        opacity: 0.4;
                    }
                    vcdk-breadcrumb.crumbfont::part(text) {
                        font-size: 14px!important;
                        font-weight: 400!important;
                        letter-spacing: .25px!important;
                        line-height: 16px!important;
                        color:#757575!important;
                    }
                `}
            </style>
            <Breadcrumbs>
                {crumbs.map((crumb) => (
                    <Breadcrumb className="crumbfont">{crumb}</Breadcrumb>
                ))}
            </Breadcrumbs>
            <Divider className="crumbdivider" />
        </>
    )
}

export default CustomBreadcrumb
   